import { render, staticRenderFns } from "./BigDivider.vue?vue&type=template&id=754d3f04&"
import script from "./BigDivider.vue?vue&type=script&lang=js&"
export * from "./BigDivider.vue?vue&type=script&lang=js&"
import style0 from "./BigDivider.vue?vue&type=style&index=0&id=754d3f04&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports